import { render } from "./AdditionalInfo.vue?vue&type=template&id=1dbb4def&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"

import "./AdditionalInfo.vue?vue&type=style&index=0&id=1dbb4def&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbb4def"]])

export default __exports__